import type { FC } from 'react';

type Props = {
  className?: string;
};
const Divider: FC<Props> = ({ className }) => {
  return <div className={className} />;
};

export default Divider;
